module.exports = __webpack_public_path__ + "img/red-timer.57e23930.svg";